import React, { useState } from "react";

import Wrapper from "components/common/wrapper/Wrapper.template";

export default function WrapperComponent({ children }) {
  const [isOpenSideNav, toggleSideNav] = useState(false);

  return (
    <Wrapper
      isOpenSideNav={isOpenSideNav}
      toggleSideNav={event => {
        event.preventDefault();

        toggleSideNav(!isOpenSideNav);
      }}
    >
      {children}
    </Wrapper>
  );
}
